import * as React from 'react';

import { clsx } from '@freelancelabs/utils';

interface Props {
    height?: number;
    width?: number;
    children?: React.ReactNode;
    className?: string;
}

const SkeletonLoader = ({ height, width, children, className }: Props) => {
    const style = {
        ...(height && { height: `${height}px` }),
        ...(width && { width: `${width}px` }),
    };
    return (
        <div className={clsx('skeleton-loader', className)} aria-busy={true} style={style}>
            <span>{children}</span>
        </div>
    );
};

export default SkeletonLoader;
